import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppLayout } from "./layout/AppLayout";
import { ProtectedRoute } from "./ProtectedRoute";
import { LoginPage } from "@features/auth/Login";
import { DashboardPage } from "@features/dashboard/DashboardPage";
import { PendientesPage } from "@features/patients/PendientesPage";
import { CargaPage } from "@features/patients/CargaPage";
import { NuevaPage } from "@features/evaluation/NuevaPage";
import { HistorialPage } from "@features/history/HistorialPage";
import { IndicadoresPage } from "@features/indicators/IndicadoresPage";
import { InformesPage } from "@features/reports/InformesPage";
import { UsuariosPage } from "@features/users/UsuariosPage";
import { AuditoriaPage } from "@features/audit/AuditoriaPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "dashboard",   element: <DashboardPage /> },
      { path: "pendientes",  element: <PendientesPage /> },
      {
        path: "nueva",
        element: (
          <ProtectedRoute roles={["Administrador", "Evaluador"]}>
            <NuevaPage />
          </ProtectedRoute>
        ),
      },
      { path: "historial",   element: <HistorialPage /> },
      {
        path: "carga",
        element: (
          <ProtectedRoute roles={["Administrador", "Programador"]}>
            <CargaPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "indicadores",
        element: (
          <ProtectedRoute roles={["Administrador", "Auditoria"]}>
            <IndicadoresPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "informes",
        element: (
          <ProtectedRoute roles={["Administrador", "Auditoria"]}>
            <InformesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "usuarios",
        element: (
          <ProtectedRoute roles={["Administrador"]}>
            <UsuariosPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "auditoria",
        element: (
          <ProtectedRoute roles={["Administrador", "Auditoria"]}>
            <AuditoriaPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
